import { FC, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import { isValueNumberCompatible } from "@ryde/shared";
import { useLandingsNavigation } from "@ryde/utils-landings";

import { GenericLandingPage } from "../generic-landing";

export const LandingPageByRouteCompanyId: FC = () => {
  const { companyId } = useParams<Record<"companyId", string>>();
  const { navigatePageNotFound } = useLandingsNavigation();

  const companyIdComputed = useMemo(() => {
    return isValueNumberCompatible(companyId) ? Number(companyId) : null;
  }, [companyId]);

  useEffect(() => {
    if (!companyIdComputed) {
      navigatePageNotFound();
    }
  }, [companyIdComputed, navigatePageNotFound]);

  return (
    companyIdComputed && <GenericLandingPage companyId={companyIdComputed} />
  );
};
